import { createContext, FC, useState } from "react";


type QuestionnaireType = {
    editState: [boolean, React.Dispatch<boolean>];
    questionnaireState: [boolean, React.Dispatch<boolean>];
    newPropertyState: [boolean, React.Dispatch<boolean>];
    classificationState: [boolean, React.Dispatch<boolean>];
    questionsState: [boolean, React.Dispatch<boolean>];
    unitFormState: [boolean, React.Dispatch<boolean>];
    pageState: [number, React.Dispatch<number>]
    searchState: [string, React.Dispatch<string>]
    // navToClassification: () => void;
    // navToFacilities: () => void;
    // navToEdit: () => void;
}
export const QuestionnaireContext = createContext<QuestionnaireType>(null!);


export const QuestionnaireContextProvider: FC = ({ children }) => {
    const editState = useState(false);
    const questionnaireState = useState(false);
    const newPropertyState = useState(false)
    const classificationState = useState(false);
    const questionsState = useState(false);
    const unitFormState = useState(false);
    const pageState = useState(1);
    const searchState = useState("");

    return <QuestionnaireContext.Provider value={{
        editState,
        questionnaireState,
        newPropertyState,
        classificationState,
        questionsState,
        unitFormState,
        pageState,
        searchState
    }}>
        {children}
    </QuestionnaireContext.Provider>
}